@if (details) {
    <section class="model-heading" aria-label="Model details">
        <header class="head">
            <div class="title">
                <span class="eyebrow">Model</span>
                <h3>{{details.name}}</h3>
            </div>
            @if (details.workspace) {
                <span class="workspace">{{details.workspace}}</span>
            }
        </header>

        @if (linqset.isProcessModel()) {
            @if (details.description) {
                <p class="description">{{details.description}}</p>
            }

            <dl class="facts">
                <div>
                    <dt>Owner</dt>
                    <dd [class.none]="!details.owner">{{details.owner || 'Not set'}}</dd>
                </div>
                <div>
                    <dt>Function</dt>
                    <dd [class.none]="!details.function">{{details.function || 'Not set'}}</dd>
                </div>
                <div>
                    <dt>Created</dt>
                    <dd [class.none]="!linqset.model.createdDate">{{linqset.model.createdDate ? (linqset.model.createdDate | date) : 'Not known'}}</dd>
                </div>
                <div>
                    <dt>Last updated</dt>
                    <dd [class.none]="!details.updated">{{details.updated ? (details.updated | date) : 'Not known'}}</dd>
                </div>
                <div>
                    <dt>Review date</dt>
                    <dd [class.none]="!linqset.model.reviewDate" [class.due]="reviewDue()">
                        {{linqset.model.reviewDate ? (linqset.model.reviewDate | date) : 'Not set'}}
                        @if (reviewDue()) {<span class="due-tag">Due</span>}
                    </dd>
                </div>
            </dl>
        }

        <dl class="lists">
            @for (l of lists; track l.label) {
                <div>
                    <dt>{{l.label}} @if (l.items.length > 0) {<span class="count">{{l.items.length}}</span>}</dt>
                    <dd>
                        @for (item of l.items; track item) {
                            <span class="chip">{{item}}</span>
                        }@empty {
                            <span class="none">None</span>
                        }
                    </dd>
                </div>
            }
        </dl>
    </section>
}
